import React from "react";
import { useParams, Navigate } from "react-router-dom";
import PdfViewer from "@/components/PdfViewer";
import { getDocumentById } from "@/data/repository";

/**
 * RepositoryDocument — routes /repository/:id to the right PDF document.
 * Unknown slugs redirect to the repository index.
 */
const RepositoryDocument = () => {
  const { id } = useParams();
  const doc = getDocumentById(id);
  if (!doc) return <Navigate to="/repository" replace />;
  return <PdfViewer document={doc} />;
};

export default RepositoryDocument;
